import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Project icon — folder shape with a tab.
 *
 * Dual-tone layered style:
 * - Folder outline (with tab) in currentColor
 * - Cyan accent fill at 8% opacity on the folder body
 * - Purple accent line at 50% opacity for the tab separator line
 * - No node dots
 */
export const ProjectIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Accent fill on the folder body */}
    <path
      d="M3 7 H9 L11 9 H21 V19 a1 1 0 0 1 -1 1 H4 a1 1 0 0 1 -1 -1 Z"
      fill="#00d4ff"
      fillOpacity={0.08}
    />
    {/* Folder outline with tab */}
    <path
      d="M3 7 H9 L11 9 H21 V19 a1 1 0 0 1 -1 1 H4 a1 1 0 0 1 -1 -1 Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Tab separator line (purple accent) */}
    <path
      d="M11 9 H21"
      fill="none"
      stroke="#a855f7"
      strokeOpacity={0.5}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

ProjectIcon.displayName = "ProjectIcon";

export default ProjectIcon;
